<template>
    <div class="card">
            <div class="card-body">
                <!--
                <h5 class="card-title">Single Day Data
                    <div class="input-group mb-2" >
                        <input type="date" v-model="displayDate" class="form-control" />
                        <button class="btn btn-default" @click="organizeData()">Display</button>
                    </div>
                </h5>
            -->

                <div v-if="loading">
                    Loading ...
                </div>
                <div v-else>
                    <div v-if="error != null">{{error}}</div>
                    <div v-if="allLocationData != null">
                        <v-container class="chart-container">
                            <Bar ref="dailyChart"
                                :options="chartOptions"
                                :data="allLocationData" />
                        </v-container>

                        <div class="input-group" >
                            <input type="date" v-model="displayDate" class="form-control" />
                            <button class="btn btn-primary" @click="organizeData()">Display</button>
                            <button class="btn btn-info" @click="resetZoom()">Reset Zoom</button>
                        </div>
                        
                        
                        
                    </div>
                </div>
            </div>
          </div>
  </template>
  
  <script>
  import pb from '../api';
  //import { useToast } from 'vue-toastification';
  //import { store } from '../store';
  //import { confirm } from '@zapadale/vue3-confirm-dialog'

  import { Bar } from 'vue-chartjs'
  import zoomPlugin from 'chartjs-plugin-zoom'
  import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
  ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, zoomPlugin)
  
  export default {
    name: 'SingleDaySolarData',
    components: {
        Bar
    },
    props: ['locations'],
    data() {
      return {
        allLocationData: null,
        loading: true,
        error: null,
        displayDate: null,
        chartOptions: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                y: {
                    //max: 4500,
                    title: {
                        text: "Wh",
                        display: true
                    }
                }
            },
            plugins: {
                zoom: {
                    pan: {
                        enabled: true,
                        mode: 'xy'
                    },
                    zoom: {
                        wheel: {
                            enabled: true
                        },
                        pinch: {
                            enabled: true
                        },
                        mode: 'xy'
                    },
                    limits: {
                        y: {min: 'original', max: 'original'}
                    }
                },
                title: {
                    display: true,
                    text: "Hourly Solar Data",
                    font: {
                        size: 24
                    }
                }
            }
        }
      };
    },
    async mounted() {
      //this.fetchNoteDetails();
      this.displayDate = this.formatDateForVue(new Date());
      this.organizeData();
    },    
    methods: {
        resetZoom() {
            let dailyChart = this.$refs.dailyChart.chart; 
            dailyChart.resetZoom();
        },
        async organizeData() {
            try {
                this.error = null;
                this.loading = true;

                let solarIds = this.locations.map(p => p.solarId).join(',');
                //let date = '2025-03-03';
                //console.log("display date is: " + this.displayDate);
                let date = this.displayDate;// this.formatDateForVue(this.displayDate);

                //let d = new Date();
                //let utcOffset = d.getTimezoneOffset();

                let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

                //let result = await pb.send(`/dailyValues?solarIds=${solarIds}&date=${date}&utcOffset=${utcOffset}`);
                let result = await pb.send(`/dailyValues?solarIds=${solarIds}&date=${date}&timezone=${encodeURIComponent(timezone)}`);
                if(result.isError) {
                    this.error = result.error;
                }
                else {
                    let data = result.data;
                    for(let i = 0; i < data.datasets.length; i++) {
                        let dataSet = data.datasets[i];
                        let solarId = dataSet.label;
                        let totalProduction = dataSet.totalProduction
                        let location =  this.locations.filter(p => p.solarId == solarId)[0]
                        dataSet.backgroundColor = location.color;
                        //dataSet.label = location.friendlyName

                        let kw = totalProduction / 1000.0;
                        //let locationTotal = result.locationTotals.filter(p => p.solarId == solarId)[0];
                        dataSet.label = location.friendlyName + ` (${this.formatNumber(kw)} kWh)`;
                    }

                    // need to convert labels to pretty labels - unfortunately this must be done client side so ugh!
                    let labels = [];
                    let timeFormat = new Intl.DateTimeFormat("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                        timeZone:  timezone,
                    });

                    for(let i = 0; i < data.labels.length; i++) {
                        let e = data.labels[i]; // this is the epoch
                        let prettyTime = timeFormat.format(new Date(e * 1000));
                        labels.push(prettyTime);
                    }
                    data.labels = labels;
                    this.allLocationData = result.data;
                }
            }
            catch(e) {
                this.error = e;
            }
            finally {
                this.loading = false;
            }

        },
        formatDateForVue(date) {
            // this forces the format in the proper date format for vue: yyyy-mm-dd
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')

            return `${year}-${month}-${day}`
        },
        formatNumber(number) {
            return new Intl.NumberFormat('en-US', {
                style: 'decimal',
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            }).format(number);
        },

    }
  };
  </script>
  
  <style scoped>  
  .card {
    /*
    cursor: pointer;
    */
  }

  .chart-container {
  flex-grow: 1;
  /*min-height: 0;*/
  min-height: 400px;

  > div {
    position: relative;
    height: 100%;
  }
}
  </style>